import clsx from "clsx";

/**
 * The section's one error state. A 404 is worth distinguishing from a real
 * failure: the Tracking Health module is a separate backend deployment, so
 * until it ships to an environment every read here answers 404 — which is a
 * fact about the environment, not something a retry can fix.
 */
function isNotFound(error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response
    ?.status;
  return status === 404;
}

export function LoadError({
  error,
  label,
  onRetry,
  bare = false,
}: {
  error: unknown;
  /** What failed to load, as a noun phrase: "this hotel", "the worklist". */
  label: string;
  onRetry: () => void;
  /** Render without the card chrome (for use inside an existing card). */
  bare?: boolean;
}) {
  const notFound = isNotFound(error);
  return (
    <div
      className={clsx(
        "text-center",
        bare
          ? "py-10"
          : "bg-white rounded-lg shadow-sm border border-[#E9E9EB] p-12",
      )}
    >
      {notFound ? (
        <>
          <p className="text-gray-600 font-medium mb-1">
            Tracking Health isn't available on this environment yet
          </p>
          <p className="text-sm text-gray-400">
            The backend module answers no reads here, so there is nothing to
            show. Nothing is broken on this page.
          </p>
        </>
      ) : (
        <>
          <p className="text-gray-600 font-medium mb-2">
            Couldn't load {label}
          </p>
          <button
            onClick={onRetry}
            className="text-sm font-medium text-brand-primary hover:text-brand-primary-hover"
          >
            Try again
          </button>
        </>
      )}
    </div>
  );
}
